import { createAsyncThunk } from '@reduxjs/toolkit';
import { getHelp as getHelpService } from './services';

const GET_HELP = 'GET_HELP';
export const getHelp = createAsyncThunk(GET_HELP, getHelpService);
